<script setup>
import { ref, defineExpose } from 'vue'
import { useGlobalStore } from '@/stores/global'

const global = useGlobalStore()

const setup = ref({
	type: 'dark',
})

const copied = ref(false)
let copiedTimeout = null

function copyHex() {
	navigator.clipboard.writeText(global.colorOfHonor.hex)
	copied.value = true
	clearTimeout(copiedTimeout)
	copiedTimeout = setTimeout(() => {
		copied.value = false
	}, 1500)
}

defineExpose({ setup })
</script>

<template>
	<div class="flex h-full flex-col gap-24 px-5 pt-24">
		<div class="grid grid-cols-2">
			<div class="flex flex-col gap-10">
				<p class="leading text-sm font-semibold uppercase tracking-widest">{{ global.colorOfHonor.name }}</p>
				<div class="flex flex-col gap-4">
					<button class="group relative flex w-fit items-center gap-3 py-1" :style="{ color: global.colorOfHonor.hex }" @click="copyHex">
						<span class="font text-sm uppercase">{{ global.colorOfHonor.hex }}</span>
						<i class="far fa-clone transition-colors duration-200 group-hover:text-white" />
						<Transition name="tooltip">
							<span v-if="copied" class="pointer-events-none absolute -top-6 left-1/2 -translate-x-1/2 rounded bg-crowns-off-white px-2 py-0.5 text-xs font-medium text-crowns-off-black">Copied</span>
						</Transition>
					</button>
					<h4 class="text-4xl font-semibold text-crowns-off-white">{{ global.colorOfHonor.name }}</h4>
				</div>
			</div>
			<div></div>
		</div>
		<div class="text-sm">
			<p>{{ global.colorOfHonor.description }}</p>
		</div>
	</div>
</template>

<style scoped>
.tooltip-enter-active {
	transition: all 0.15s ease;
}
.tooltip-leave-active {
	transition: all 0.4s ease;
}
.tooltip-enter-from,
.tooltip-leave-to {
	opacity: 0;
	top: -0.75rem;
}
</style>
